/** @format */

export const SELL_BALANCE_ENABLED_FLAG = 'BOO-3170-(sell-balance)' as const;
export const ACCESSORIES_CHECKLIST_FLAG =
    'LOVE-1153-(sell-journey-accessories-checklist)' as const;
export const VAT_REGISTERED_BUY_FLAG = 'BOO-3485-(vat-registered-buy)' as const;
export const NL_SEARCH_FLAG = 'TUR-3496-(nl-search)' as const;
